import React, { Component } from 'react'

import * as Sentry from '@sentry/react'
import { Route, Switch } from 'react-router-dom'

import onlyIfAuthenticated from '../components/hocs/onlyIfAuthenticated'
import onlyIfUnauthenticated from '../components/hocs/onlyIfUnauthenticated'
import withLeftDrawer from '../components/hocs/withLeftDrawer'
import GlobalNotifications from '../components/ui/notifications/GlobalNotifications'

import AuthenticatedRoutes from './authenticated/AuthenticatedRoutes'
import UnauthenticatedRoutes from './unauthenticated/UnauthenticatedRoutes'

const SentryRoute = Sentry.withSentryRouting(Route)

class Routes extends Component {
  render() {
    return (
      <div>
        <GlobalNotifications />
        <Switch>
          <SentryRoute path="/app" component={onlyIfAuthenticated(AuthenticatedRoutes)} />
          <SentryRoute component={onlyIfUnauthenticated(UnauthenticatedRoutes)} />
        </Switch>
        <div className="mb-1" id="google_translate_element" />
      </div>
    )
  }
}

export default withLeftDrawer(Routes)



// WEBPACK FOOTER //
// ./src/routes/Routes.js